import { Pipe, PipeTransform } from '@angular/core';


const now = new Date();


export const age = (yearBuilt: string | number | null) => {
    if (yearBuilt === null) {
        return null;
    }
    const year = typeof yearBuilt === 'string' ? parseInt(yearBuilt) : yearBuilt;
    if (isNaN(year)) {
        return;
    }
    if (year > now.getFullYear()) {
        return;
    }
    const age = now.getFullYear() - year;
    if (age < 0) {
        return;
    }
    return age;
};


@Pipe({
    name: 'age',
})
export class AgePipe implements PipeTransform {

    transform(value: string | number | null) {
        return age(value);
    }
}
